import React from 'react';
import ButtonSnippet from '@/components/common/HtmlElements/ButtonSnippet';
import IQuestionButton from '@/components/interfaces/graphql/HtmlElement/QuestionButton';

interface SnippetProps {
  questionButton: IQuestionButton;
}

const Snippet = ({
  questionButton: { id, type, data: { backgroundColor = 'blue', buttonTextEn, buttonTextEs } },
}: SnippetProps) => (
  <ButtonSnippet
    backgroundColor={backgroundColor}
    buttonTextEn={buttonTextEn}
    buttonTextEs={buttonTextEs}
    id={id}
    type={type}
  />
);

export default Snippet;
